import { toNumber } from 'lodash'
import { useTranslation } from 'react-i18next'
import NumberFormat from 'react-number-format'

const CurrencyFormatter = ({ value, showCents = false, ...rest }) => {
  const { i18n } = useTranslation()
  const isFrench = i18n.languages[0] === 'fr'

  return (
    <NumberFormat
      value={toNumber(value)}
      displayType="text"
      thousandSeparator={isFrench ? '\u00a0' : ','}
      decimalSeparator={isFrench ? ',' : '.'}
      prefix={isFrench ? undefined : '$'}
      suffix={isFrench ? '\u00a0$' : undefined}
      decimalScale={2}
      fixedDecimalScale={showCents}
      {...rest}
    />
  )
}

export default CurrencyFormatter
